<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <baseaktarim
      :logo="'biletbanklogo'"
      :title="$t('Ticket-Transfer')"
      v-model="items"
      v-on:submitfile="SubmitFile"
      :status="status"
    ></baseaktarim>
  </div>
</template>


<script>
import baseaktarim from "../aktarimbilet/baseaktarim";
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      items: [],
      status: tool.NewSatatus(),
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  components: {
    baseaktarim,
    yetkidialog,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  methods: {
    SubmitFile(files,params) {
      var dizi = [];

      dizi = files;

      let formData = new FormData();
      for (var i = 0; i < files.length - 1; i++) {
        let file = files[i];
        formData.append("files[" + i + "]", file);
      }

      formData.append("AcenteKodu", dizi[files.length - 1].AcenteKodu);
      formData.append("InternetSatis", params && params.InternetSatis ? true : false);
      formData.append(
        "ServisAlisServis",
        dizi[files.length - 1].ServisAlisServis
      );
      this.status.loading = true;

      tool
        .api_file_post(this, "ArkmanTicketStream/BiletbankStream", formData)
        .then(
          (response) => {
            this.items = response.body;
            this.status.loading = false;
          },
          (response) => {
            this.status.loading = false;

            this.status = tool.responseToStatus(response);
          }
        );
    },
  },
};
</script>
